import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardHeader, Col, Input, Label, Row } from 'reactstrap';
import { createSelector } from 'reselect';
import CustomSelectWithSearch from '../../../../Components/Common/CustomSelectWithSearch';
import { setCatalogId, setFbBusinessId, setFbCatalogPublishSettings, setPublishLoader, setSelectedBusinessId, setSelectedCreativesPublish } from '../../../../slices/publish/reducer';
import { toggleFacebookModal, toggleFbBusinessAuthModal, toggleFbCreateCatalogModal } from '../../../../slices/modals/reducer';
import BusinessAuthNeedModal from './BusinessAuthNeedModal';
import { createFacebookBusinessAuth, getFacebookCatalogList, publishFacebookCatalog, refreshFacebookBusinessList, refreshFacebookCatalogList } from '../../../../slices/publish/facebook/thunk';
import CreateCatalogModal from './CreateCatalogModal';
import { toast } from 'react-toastify';

function CatalogSettings() {
  const dispatch = useDispatch();

  const selectFacebookState = createSelector(state => state, state => ({
    selectedCreativesPublish: state.Publish.selectedCreativesPublish,
    versions: state.Campaign.versions,
    currentCampaign: state.Campaign.currentCampaign,
    userFacebookId: state.Publish.userFacebookId,
    businessList: state.Publish.businessList,
    catalogList: state.Publish.catalogList,
    fbBusinessId: state.Publish.fbBusinessId,
    catalogId: state.Publish.catalogId,
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    isBusinessAuthenticated: state.Publish.isBusinessAuthenticated
  }));
  const {
    selectedCreativesPublish,
    versions,
    currentCampaign,
    userFacebookId,
    businessList,
    catalogList,
    fbBusinessId,
    catalogId,
    isFacebookPropertiesSet,
    isBusinessAuthenticated
  } = useSelector(selectFacebookState);

  const [businesses, setBusinesses] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState({});
  const [catalogs, setCatalogs] = useState([]);
  const [selectedCatalog, setSelectedCatalog] = useState({});

  useEffect(() => {
    if (Array.isArray(businessList) && businessList.length > 0) {
      setBusinesses(businessList.map(item => {
        return { ...item, value: (item?.businessId ? item?.businessId : item?.id) }
      }))
    }
  }, [businessList]);

  useEffect(() => {
    if (Array.isArray(catalogList) && catalogList.length > 0) {
      setCatalogs(catalogList.map(item => {
        return { ...item, value: item.catalogId }
      }))
    }
  }, [catalogList]);

  useEffect(() => {
    if (Array.isArray(businessList) && businessList.length > 0 && fbBusinessId) {
      const foundBusiness = businessList.find(business => (business?.businessId ? business?.businessId : business?.id ) === fbBusinessId);
      if (foundBusiness) {
        setSelectedBusiness({ ...foundBusiness, value: fbBusinessId });
      }
    }
  }, [fbBusinessId]);

  useEffect(() => {
    if (Array.isArray(catalogList) && catalogList.length > 0 && catalogId) {
      const foundCatalog = catalogList.find(catalog => catalog.catalogId === catalogId);
      if (foundCatalog) {
        setSelectedCatalog({ ...foundCatalog, value: catalogId });
      }
    }
  }, [catalogId]);

  function goBack() {
    dispatch(setSelectedCreativesPublish([]));
    dispatch(setFbCatalogPublishSettings(false));
  }

  async function handleBusinessSelect(item) {
    setSelectedBusiness(item);
    // if (userFacebookId === item?.userFbId) { 
    console.log("business item", item);
    dispatch(setFbBusinessId(item.value));
    await dispatch(getFacebookCatalogList({businessId: item.value}));
    // }
    //  else {
    //   dispatch(toggleFbBusinessAuthModal());
    // }
  }

  async function handleCatalogSelect(item) {
    setSelectedCatalog(item);
    dispatch(setCatalogId(item.value));
  }

  async function refreshBusiness() {
    await dispatch(refreshFacebookBusinessList());
  }

  async function refreshCatalogs() {
    await dispatch(refreshFacebookCatalogList());
  }

  function showCreateCatalogModal() {
    if (fbBusinessId) {
      dispatch(toggleFbCreateCatalogModal());
    } else {
      toast.error('Please select business first', { autoClose: 3000 });
    }
  }

  async function handlePublish() {
    if (isFacebookPropertiesSet) {
      if (isBusinessAuthenticated) {
        dispatch(setPublishLoader(true));
        await dispatch(publishFacebookCatalog());
        dispatch(setPublishLoader(false));
      } else {
        dispatch(createFacebookBusinessAuth());
      }
    } else {
      showFacebookModal();
    }
  }


    function showFacebookModal() {
      dispatch(toggleFacebookModal());
    }

    return (
      <React.Fragment>
        <Row>
          <Col>
            <Card>
              <div className='w-100 p-3 d-flex align-items-center justify-content-between'>
                <div className='d-flex align-items-center'>
                  <button className='btn btn-light btn-icon fw-bold' onClick={goBack}>
                    <i className='ri-arrow-left-line'></i>
                  </button>
                </div>
                <div className='d-flex align-items-center justify-content-end'>
                  <svg aria-label="Meta logo" height="30" role="img" viewBox="0 0 150 100" width="72"><defs><linearGradient gradientUnits="userSpaceOnUse" id=":r0:" x1="124.599" x2="159.703" y1="96.689" y2="57.25"><stop offset="0.21" stop-color="#0278F1"></stop><stop offset="0.533" stop-color="#0180FA"></stop></linearGradient><linearGradient gradientUnits="userSpaceOnUse" id=":r1:" x1="43.859" x2="0" y1="4.984" y2="63.795"><stop offset="0.427" stop-color="#0165E0"></stop><stop offset="0.917" stop-color="#0180FA"></stop></linearGradient><linearGradient gradientUnits="userSpaceOnUse" id=":r2:" x1="28.409" x2="134.567" y1="28.907" y2="71.769"><stop stop-color="#0064E0"></stop><stop offset="0.656" stop-color="#0066E2"></stop><stop offset="1" stop-color="#0278F1"></stop></linearGradient></defs><path d="M107.654 0c-12.3 0-21.915 9.264-30.618 21.032C65.076 5.802 55.073 0 43.103 0 18.698 0 0 31.76 0 65.376 0 86.41 10.177 99.679 27.223 99.679c12.268 0 21.092-5.784 36.778-33.203 0 0 6.539-11.547 11.037-19.501a514.1 514.1 0 0 1 4.98 8.227l7.356 12.374c14.329 23.977 22.312 32.103 36.778 32.103C140.758 99.68 150 86.23 150 64.757 150 29.56 130.88 0 107.654 0ZM52.039 59.051C39.322 78.987 34.922 83.455 27.841 83.455c-7.287 0-11.617-6.397-11.617-17.804 0-24.404 12.167-49.359 26.672-49.359 7.855 0 14.42 4.537 24.474 18.93-9.547 14.645-15.33 23.83-15.33 23.83Zm47.999-2.51-8.795-14.667c-2.38-3.87-4.66-7.428-6.862-10.689 7.927-12.234 14.465-18.33 22.241-18.33 16.155 0 29.079 23.786 29.079 53.002 0 11.137-3.647 17.599-11.205 17.599-7.244 0-10.704-4.785-24.458-26.914Z" fill="#0180FA"></path><path d="M145.119 34.888h-14.878c3.44 8.718 5.46 19.42 5.46 30.969 0 11.137-3.647 17.599-11.205 17.599-1.403 0-2.663-.18-3.884-.63V99.5a33.48 33.48 0 0 0 3.54.18C140.758 99.68 150 86.23 150 64.756c0-10.702-1.768-20.882-4.881-29.87Z" fill="url(#:r0:)"></path><path d="M43.103 0c.253 0 .505.003.756.008v16.308c-.319-.016-.64-.024-.962-.024-14.138 0-26.055 23.706-26.65 47.503H.014C.588 30.77 19.08 0 43.103 0Z" fill="url(#:r1:)"></path><path d="M43.103 0c11.115 0 20.534 5.004 31.4 17.913 3.055 3.817 6.74 8.777 10.682 14.511l.017.025.024-.003c1.939 2.912 3.94 6.05 6.017 9.428l8.795 14.668c13.754 22.13 17.214 26.913 24.458 26.913h.103v16.22c-.148.003-.297.004-.447.004-14.466 0-22.449-8.126-36.778-32.103l-7.356-12.374a587.065 587.065 0 0 0-2.287-3.822l.019-.045c-5.483-8.971-8.971-14.454-11.962-18.44l-.05.037c-9.15-12.59-15.42-16.64-22.842-16.64h-.034V.001l.24-.001Z" fill="url(#:r2:)"></path></svg>
                  {/* <button className={'btn btn-info btn-facebook' + (isFacebookPropertiesSet ? ' btn-facebook' : ' btn-soft-facebook')} onClick={showFacebookModal}>
                    <i className='ri-facebook-fill'></i>
                  </button> */}
                  {fbBusinessId && catalogId ?
                    <button className='btn btn-success ms-3' onClick={handlePublish}>
                      Publish
                    </button>
                    : null}
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xxl={8} xl={8} lg={8} md={12} sm={12}>
            <Card>
              <CardHeader>
                Publish Settings
              </CardHeader>
              <CardBody>
                <Row>
                  <Col className='d-flex flex-row align-items-center'>
                    <div className='d-flex flex-column'>
                      <Label>Businesses</Label>
                      <div className='w-100 d-flex align-items-center flex-nowrap'>
                        <CustomSelectWithSearch
                          tag='div'
                          className='form-select'
                          placeholder='Select Business'
                          onChange={(business) => handleBusinessSelect(business)}
                          options={businesses}
                          value={(selectedBusiness?.name || '')}
                        />
                        <button className='btn btn-soft-info btn-icon ms-2' onClick={refreshBusiness}>
                          <i className='mdi mdi-refresh fs-5'></i>
                        </button>
                      </div>
                    </div>
                    <div className='ms-3 d-flex flex-column'>
                      <Label>Catalogs</Label>
                      <div className='w-100 d-flex align-items-center flex-nowrap'>
                        <CustomSelectWithSearch
                          tag='div'
                          className='form-select'
                          placeholder='Select Catalog'
                          onChange={(catalog) => handleCatalogSelect(catalog)}
                          options={catalogs}
                          value={(selectedCatalog?.name || '')}
                        />
                        <button className='btn btn-soft-info btn-icon ms-2' onClick={refreshCatalogs}>
                          <i className='mdi mdi-refresh fs-5'></i>
                        </button>
                        <button className='btn btn-ghost-success btn-icon ms-2' onClick={showCreateCatalogModal}>
                          <i className='mdi mdi-plus fs-5'></i>
                        </button>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={12} sm={12}>
            <Card>
              <CardHeader>
                Banners to be published in Facebook Catalog
              </CardHeader>
              <CardBody>
                <div className='w-100 d-flex flex-column'>
                  {selectedCreativesPublish ? selectedCreativesPublish.map((item, idx) => {
                    const foundVersion = versions.find(version => version._id === item.versionId);
                    return (
                      <div className='w-100 d-flex flex-row align-items-center' key={idx}>
                        {currentCampaign.bannerType === 'html' &&
                          <i className='ri-html5-fill fs-15'></i>
                        }
                        {currentCampaign.bannerType === 'image' &&
                          <i className='bx bxs-image-alt fs-15'></i>
                        }
                        <p className='ms-1 mb-0'>{foundVersion.name} {item.size}</p>
                      </div>
                    )
                  }) : null}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <BusinessAuthNeedModal />
        <CreateCatalogModal />
      </React.Fragment >
    )
  }

  export default CatalogSettings
